import {all, call, fork, put, takeLatest} from "redux-saga/effects"
import types from "actions/types"
import {loadCustomerApprovalsFailure, loadCustomerApprovalsSuccess} from "actions/customer"

export default (api) => {

  function* loadCustomerApprovals({token}) {
    try {
      const response = yield call(api.viewApproval, token)

      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          yield put(loadCustomerApprovalsSuccess(data.result))
        },
        function* onFail(key, message, code) {
          const errorMessage = `Failed to load approvals: ${message}`
          yield put(loadCustomerApprovalsFailure(errorMessage, code))
        }
      )
    } catch (e) {
      yield put(loadCustomerApprovalsFailure("An unexpected error occurred. Please try again."))
      console.error(e)
    }
  }

  function* myWatcher() {
    yield all([
      takeLatest(types.CUSTOMER_APPROVALS_LOAD_ATTEMPT, loadCustomerApprovals),
    ])
  }

  function* watcher() {
    yield fork(myWatcher)
  }

  return {
    watcher,
  }
}
